<div class="app-timesheet">
  <h4>Current project:</h4>
  @if ((currentProj$ | async); as project) {
    <div
      class="current-project"
      >
      <p>{{ project.name }}</p>
      <button
        mat-flat-button
        class="full-width btn-blue"
        (click)="onHandleClockOut()"
        [disabled]="isLoading"
        >
        {{ isLoading ? "loading..." : "CLOCK OUT" }}
      </button>
    </div>
  } @else {
    <div class="no-project">None</div>
    <button
      mat-flat-button
      class="full-width btn-blue"
      (click)="onHandleClockIn()"
      [disabled]="isLoading"
      >
      {{ isLoading ? "loading..." : "CLOCK IN" }}
    </button>
  }
</div>
